import { Injectable } from "@angular/core";
import { BaseHttpService } from "../base-http.service";
import { UserService } from "../user/user.service";
import { HttpClient } from "@angular/common/http";
import { API } from "../../model";
import { MessageService } from "../../modules/shared/message/message.service";
import { ProgressBarService } from "../../modules/shared/progress-bar/progress-bar.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class ApiService extends BaseHttpService {

  constructor(protected http: HttpClient,
              protected userService: UserService,
              protected translateService: TranslateService,
              protected progressBarService: ProgressBarService,
              protected messageService: MessageService) {
    super(http, userService, translateService, progressBarService, messageService);
  }

  async getApis(): Promise<Array<API>> {
    return (await this.get<Array<API>>("unauthenticated/apis/list")).result;
  }
}
